import { IconAIStar, IconAIVoiceAgent } from '@/assets/static/icons';
import { FEATURES_HOME_URL } from '@shared/constants/redirect';
import { ROLE_MAPS } from '@shared/constants/roles';
import { Button } from 'antd';
import {
  RiContactsBookLine,
  RiDashboardLine,
  RiFlashlightLine,
  RiSettings3Fill,
  RiSurveyLine,
  RiExternalLinkLine,
  RiDiscussLine,
} from 'react-icons/ri';
import { TbLayoutGridAdd } from 'react-icons/tb';
import { SidebarItemType } from './sidebar.types';
import { TFunction } from 'i18next';
import { capitalize } from '@shared/utils/capitalize';
import { PLAN_MAPS } from '@shared/constants/plans';
import { CgBolt } from 'react-icons/cg';

type SidebarItemTypeII = SidebarItemType & {
  external?: string;
};

const extraAnalyticMenu = (t: TFunction) => (
  <div className="flex items-center justify-center">
    <Button className="text-primary-500! text-[10px]! uppercase h-5! rounded-full! px-2.5! py-0.5! pointer-events-none! grow-0! tracking-wider">
      {t('ai_beta')}
    </Button>
  </div>
);

const extraNewBadge = (t: TFunction) => (
  <div className="flex items-center justify-center">
    <Button className="text-primary-500! text-[10px]! uppercase h-5! rounded-full! px-2.5! py-0.5! pointer-events-none! grow-0! tracking-wider">
      {t('new')}
    </Button>
  </div>
);

export const items = (t: TFunction): SidebarItemTypeII[] => [
  {
    key: '/dashboard',
    icon: <RiDashboardLine className="size-6" data-tour-id="dashboard" />,
    label: capitalize(t('dashboard')),
  },
  {
    key: '/analytics/ai-dashboard',
    mobileKey: '/analytics',
    icon: <RiSurveyLine className="size-6" data-tour-id="analytics" />,
    label: (
      <span className="flex">
        {capitalize(t('analytics'))}
        <IconAIStar className="w-[13px]! h-[15px]!" />
      </span>
    ),
    planPrivilege: PLAN_MAPS.AI_DASHBOARD_AI_REPORT_ANALYTICS_VIEW,
    extra: extraAnalyticMenu(t),
  },
  {
    key: '/ai-assistance/ai-voice-agent',
    mobileKey: '/ai-assistance',
    icon: <IconAIVoiceAgent className="size-6" data-tour-id="ai_assistance" />,
    label: capitalize(t('ai_assistance')),
    extra: extraAnalyticMenu(t),
  },
  {
    key: '/contacts',
    icon: <RiContactsBookLine className="size-6" data-tour-id="contacts" />,
    label: capitalize(t('contact', { count: 5 })),
    rolePrivilege: ROLE_MAPS.CONTACTS_CONTACTS_LIST,
  },
  {
    key: '/tools/download-apps',
    icon: <TbLayoutGridAdd className="size-6 rotate-270" data-tour-id="tools" />,
    label: capitalize(t('tools')),
    extra: extraNewBadge(t),
  },
  {
    key: '/calilio-hub/overview',
    mobileKey: '/calilio-hub',
    icon: <CgBolt className="text-primary-400! border border-gray-800 rounded-full" />,
    label: capitalize(t('calilio_hub')),
  },
  {
    key: '/powerdialer',
    icon: <RiFlashlightLine className="size-6" data-tour-id="power_dialer" />,
    label: (
      <span className="flex w-full items-center justify-between whitespace-nowrap">
        {capitalize(t('power_dialer'))}
        <RiExternalLinkLine size={20} />
      </span>
    ),
    planPrivilege: PLAN_MAPS.POWER_DIALER_POWER_CAMPAIGN_VIEW,
    external: `${FEATURES_HOME_URL}/app/powerdialer`,
  },
  {
    key: '/bulk-messaging',
    icon: <RiDiscussLine className="size-6" data-tour-id="bulk_messaging" />,
    label: capitalize(t('bulk_messaging')),
    rolePrivilege: ROLE_MAPS.BULK_MESSAGING_CAMPAIGNS_VIEW,
  },
  {
    key: '/settings/my-profile',
    mobileKey: '/settings',
    icon: <RiSettings3Fill className="size-6" data-test-id="settings" data-tour-id="settings" />,
    label: capitalize(t('settings')),
  },
];
